/**
 * Everything one open show sheet loads: its episodes, and its detail record.
 *
 * Two fetches with the same lifetime and the same trigger, so they are asked
 * for together. Both are cached in their own modules; this only pairs them.
 */
import type { SimklClient } from "@/api/client";
import type { ShowDetail } from "@/store/details";
import type { ShowEpisodes } from "@/store/useShowEpisodes";
import { useShowDetail } from "@/store/useShowDetail";
import { useShowEpisodes } from "@/store/useShowEpisodes";

export interface SheetData extends ShowEpisodes {
  detail: ShowDetail | null;
}

export function useSheetData(client: SimklClient, simklId: number | null): SheetData {
  const episodes = useShowEpisodes(client, simklId);
  const detail = useShowDetail(client, simklId);
  return { ...episodes, detail };
}
